import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Button, Box, Heading } from 'grommet';
import TextTruncate from 'react-text-truncate';
import Img from 'gatsby-image';
import slugGen from '../../../gatsby/slugGen';

const StyledCard = styled(Box)`
  position: relative;
  & + & {
    margin-top: 24px;
  }
`;

const StyledCardCount = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
  font-size: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  font-weight: 700;
`;

const StyledCardContent = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: center;

  @media (min-width: ${props => props.theme.global.breakpoints.small.value}px) {
    flex-flow: row nowrap;
    align-items: flex-start;
  }
`;
const StyledCardHeading = styled.h2``;

const StyledCardFigure = styled.figure`
  position: relative;
  max-width: 280px;
  width: 100%;
  height: auto;
  margin: 0;
  flex-shrink: 0;
  @media (min-width: ${props => props.theme.global.breakpoints.small.value}px) {
    margin-right: 16px;
  }

  img,
  svg {
    max-width: 100%;
    height: auto;
  }
`;

const StyledCardInfoContainer = styled.div`
  padding: 0 16px 16px 16px;
  flex-grow: 1;
`;
const StyledCardDesc = styled.div`
  margin-bottom: 16px;
`;
const StyledCardPriceColumn = styled.div`
  padding: 16px;
  font-weight: 700;

  @media (min-width: ${props => props.theme.global.breakpoints.small.value}px) {
    text-align: right;
    width: 120px;
  }
`;
const StyledCardKeyList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  li + li {
    margin-left: 16px;
  }
`;

const StyledCardLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
const ListingCard = ({ vehicle, search }) =>
{
  if (!vehicle || !vehicle.make) {
    return null;
  }

  const {
    mediaCount,
    media,
    year,
    ageIdentifier,
    desc,
    make,
    model,
    transmission,
    mileage,
    bodyStyle,
    sold,
    price,
    fuelType,
    variant,
  } = vehicle;

  const mainPhoto =
    media && media.length
      ? `https://res.cloudinary.com/hyperengine/${media[0].resourceType}/upload/w_500,f_auto/${media[0].id}`
      : null;

  const slug = `/${slugGen([
    `${vehicle.vehicleType ? vehicle.vehicleType : 'car'}-sales`,
    vehicle.make.name,
    vehicle.model.name,
    vehicle.slug || `${vehicle.variant}-${vehicle.id}`,
  ])}`;

  return (
    <StyledCard
      direction="column"
      elevation="small"
      pad="medium"
      alignSelf="stretch"
      round="xsmall"
      animation="slideUp"
    >
      <StyledCardContent>
        <StyledCardFigure>
          {(media && media.length > 0 && media[0].imageFile) || (media && media.length > 0 && search) ? (
            <>
              <StyledCardCount>{mediaCount}</StyledCardCount>

              {search ? (
                <img src={mainPhoto} alt={`${vehicle.make.name} ${vehicle.model.name}`} />
              ) : (
                  <Img
                    fluid={media[0].imageFile.childImageSharp.fluid}
                    alt={`${vehicle.make.name} ${vehicle.model.name}`}
                  />
                )}
            </>
          ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width={640} height={480} viewBox="0 0 640 480">
                <rect x={0} y={0} rx={0} ry={0} width={640} height={480} fill="#f2f2f2" />
              </svg>
            )}
        </StyledCardFigure>
        <StyledCardInfoContainer>
          <Heading level="2" size="small" margin={{ top: '0' }}>
            <StyledCardLink to={slug}>
              {make.name} {model.name} {variant}
            </StyledCardLink>
          </Heading>

          <StyledCardKeyList>
            {year && (
              <li>
                {year && <>{year}</>}
                {ageIdentifier && <>({ageIdentifier})</>}
              </li>
            )}
            {bodyStyle && <li>{bodyStyle}</li>}
            {mileage && <li>{mileage} miles</li>}
            {transmission && <li>{transmission}</li>}
            {fuelType && <li>{fuelType}</li>}
          </StyledCardKeyList>

          <StyledCardDesc>
            {}
            <TextTruncate line={3} element="span" truncateText="…" text={desc} />
          </StyledCardDesc>
          <Link to={slug}>
            <Button primary label="View" />
          </Link>
        </StyledCardInfoContainer>
        <StyledCardPriceColumn>{sold ? <>SOLD £{price}</> : <>£{price}</>}</StyledCardPriceColumn>
      </StyledCardContent>
    </StyledCard>
  );
};

export default ListingCard;
